// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___21Ewz","overlayModal":"style__overlayModal___1FCsv","overlayModalInner":"style__overlayModalInner___Skz6o","overlayCloseButton":"style__overlayCloseButton___GBRK-","overlayModalTitle":"style__overlayModalTitle___3aq0h","overlayModalText":"style__overlayModalText___3Qsgb","overlayModalTextBold":"style__overlayModalTextBold___yfEFs","overlayModalButtons":"style__overlayModalButtons___1fvzx","overlayModalButtonsItem":"style__overlayModalButtonsItem___14ygC","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___1jlGg","buttonActive":"style__buttonActive___yzGaU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-leave/style.css
// module id = 329
// module chunks = 0